var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1025_4362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1025_4362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 20.9983C13.9614 20.9972 15.8689 20.3549 17.4316 19.1693C18.9943 17.9837 20.1266 16.3197 20.656 14.4309C21.1854 12.5421 21.0828 10.532 20.364 8.70691C19.6451 6.8818 18.3494 5.3417 16.6741 4.32126C14.9988 3.30082 13.0359 2.85597 11.0844 3.0545C9.13291 3.25302 7.29978 4.08403 5.86433 5.42093C4.42888 6.75782 3.46979 8.5273 3.13319 10.4598C2.79659 12.3923 3.10092 14.3818 3.99982 16.1253L2.99982 20.9983L7.87282 19.9983C9.1485 20.6575 10.5639 21.0004 11.9998 20.9983Z",
    stroke: "#303030",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8d7626568a1eb4af9525b0cbf80f1d44.svg";
export { ForwardRef as ReactComponent };